import { AuthConstantS, type AuthTypeS } from '@/features/Auth/outbound/share';
import { T } from '@/libs/translation';
import { toLowerCase } from '@/libs/util/toLowerCase';
import { Icon, Typo } from '@/ui/component/atom';
import { ModalBodyView } from '@/ui/component/cell';
import { chunk, filter, keys, map, pipe, toArray } from '@fxts/core';
import { html } from 'rune-ts';
import klass from './EmailDuplicated.module.scss';

export interface EmailDuplicatedViewData {
  email: string;
  error: AuthTypeS.SignupErrorType;
}

export class EmailDuplicatedView extends ModalBodyView<EmailDuplicatedViewData> {
  override template() {
    const { error, email } = this.data;

    return html`<div class="${klass.container}">
      ${new Typo({
        text: html.preventEscape(!error.extra.length ? T('auth.signup.duplicated') : T('auth.signup.duplicated_sns')),
      })}
      ${!error.extra.length
        ? html` <div class="${klass.email_container}">${new Typo({ text: email }, { color: 'accent' })}</div> `
        : html`
            <div class="${klass.sns_container}">
              ${new Typo(
                { text: T('auth.signup.email_sns_duplicated') },
                { typo: 'p2', color: 'gray_50', klass: klass.guide },
              )}
              ${pipe(
                AuthConstantS.USER_LOGIN_SNS_TYPE_MAPPER,
                keys,
                filter((type) => error.extra.includes(type)),
                chunk(error.extra.length > 4 ? 3 : 4),
                map(
                  (socials) =>
                    html`<div class="${klass.sns_wrapper}">
                      ${socials.map(
                        (social) =>
                          html`<div class="${klass.sns}">
                            ${new Icon({ name: `${toLowerCase(social)}_logo`, size: 21 })}
                            ${new Typo({ text: T(`common.${social}`) }, { typo: 'p2', color: 'gray_80' })}
                          </div>`,
                      )}
                    </div>`,
                ),
                toArray,
              )}
            </div>
          `}
    </div>`;
  }
}
